import React from 'react';
import { RoutePermittedRole } from '../../shared/constants/AppEnums';
import CreateCountry from './countries/create-country';

const Brand = React.lazy(() => import('./brand'));
const CreateBrand = React.lazy(() => import('./brand/create-brand'));

const Countries = React.lazy(() => import('./countries'));
const Languages = React.lazy(() => import('./languages'));
const CreateLanguage = React.lazy(() => import('./languages/create-language'));
const Currencies = React.lazy(() => import('./currencies'));
const CreateCurrency = React.lazy(() => import('./currencies/create-currency'));
const Penalties = React.lazy(() => import('./penalties'));
const EmailAccount = React.lazy(() => import('./email-account'));
const RewardPoints = React.lazy(() => import('./reward-points'));
const GeneralConfiguration = React.lazy(
  () => import('./general-configuration'),
);
const CreateEmail = React.lazy(
  () => import('./email-account/create-email'),
);
const OrderReasons = React.lazy(() => import('./order-reasons'));
const CreateOrUpdateOrderReason = React.lazy(
  () => import('./order-reasons/create-or-update'),
);

export const configurationConfig = [
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/general-configuration',
    element: <GeneralConfiguration />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/brands',
    element: <Brand />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/brands/create',
    element: <CreateBrand />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/brands/edit/:id',
    element: <CreateBrand />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/countries',
    element: <Countries />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/countries/create',
    element: <CreateCountry />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/countries/edit/:id',
    element: <CreateCountry />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/languages',
    element: <Languages />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/languages/create',
    element: <CreateLanguage />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/languages/edit/:id',
    element: <CreateLanguage />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/currencies',
    element: <Currencies />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/currencies/create',
    element: <CreateCurrency />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/currencies/edit/:id',
    element: <CreateCurrency />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/reward-points',
    element: <RewardPoints />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/penalties',
    element: <Penalties />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/penalties',
    element: <Penalties />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/email-account',
    element: <EmailAccount />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/email-account/create',
    element: <CreateEmail />,
  }, {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/email-account/edit/:id',
    element: <CreateEmail />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/order-reasons',
    element: <OrderReasons />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/order-reasons/create',
    element: <CreateOrUpdateOrderReason />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/configuration/order-reasons/edit/:id',
    element: <CreateOrUpdateOrderReason />,
  },
];
